module.exports = __webpack_public_path__ + "../resources/img/img_visual01.75347818.jpg";